import React from "react";
import scrmLogo from "../../public/images/svg/scrmLogo.svg";

/**
 * StyledHeader Component
 * Consolidated styling: .header--main from src/styles/components.css
 *
 * REFACTOR NOTES:
 * - Replaced inline Tailwind with component class
 * - Maintains responsive height via .header--main
 */
const StyledHeader = () => (
  <header className="header--main">
    <div
      id="header-content"
      className="flex flow-row items-center h-full justify-between"
    >
      <div id="branding-area" className="pl-4 flex-1">
        <a href="/public" className="flex flex-row">
          <img src={scrmLogo} className="h-8 mx-2" alt="Logo" />
        </a>
      </div>
    </div>
  </header>
);

export default StyledHeader;
